export const SOCKET_ENTITY = {
  pulseSiteSummary: 'PulseSiteSummary',
  pulseTurbineSummary: 'PulseTurbineSummary',
  globalView: 'GlobalView'
};

export const INSTALLED_PRODUCTS_VIEW_SUMMARY = 'summary';

export const TURBINES_KEYS = {
  genTotalKwAnalog: 'genTotalKwAnalog',
  ngpAnalog: 'ngpAnalog',
  pcntLoadAnalog: 'pcntLoadAnalog',
  t5AverageTemperatureAnalog: 't5AverageTemperatureAnalog'
};

export const TURBINES_VARIANTS = {
  alert: 'alert',
  active: 'active',
  shutdown: 'shutdown',
  warning: 'warning',
  ok: 'ok',
  offline: 'offline'
};

export const TURBINES_POWER_STATUS = {
  offline: 'offline',
  notReadyToRunStatus: 'notReadyToRunStatus',
  onLoadStatus: 'onLoadStatus',
  readyToLoadStatus: 'readyToLoadStatus',
  readyToRunStatus: 'readyToRunStatus',
  runningStatus: 'runningStatus',
  startingStatus: 'startingStatus',
  stoppingStatus: 'stoppingStatus'
};

export const TURBINES_SORT = {
  asc: 'asc',
  desc: 'desc'
};

export const TURBINES_PATHS = {
  turbineData: 'data.info',
  sentAt: 'meta.sentAt'
};

export const TURBINES_DETAILS_PATHS = {
  alarms: 'data.info.alarms',
  shutdowns: 'data.info.shutdowns',
  summary: 'summary.tab.table',
  control: 'control.tab',
  generatorSummary: 'generator.summary',
  generatorTemperatures: 'generator.temperatures.table',
  turbineInstruments: 'turbine.instruments',
  turbineFuelSystem: 'turbine.fuelSystem',
  turbineStarter: 'turbine.starter.table',
  vibrationBearings: 'vibrationBearings.tab',
  lube: 'lube.tab',
  enclosure: 'enclosure.tab'
};

export const TURBINES_HISTORY_PATHS = {
  unit: 'data.series.0.metrics.0.unit'
};

export const TURBINE_IS_ACTIVE = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};
